import { PROVIDERS_HEADER_TITLES } from 'utils/constants';
import { PROVIDERS_FIELDS_NAME } from 'utils/enums';

export const COLUMNS_CONFIG = [
	{ field: PROVIDERS_FIELDS_NAME.PROVIDER, headerName: PROVIDERS_HEADER_TITLES.PROVIDER, flex: 1 },
	{ field: PROVIDERS_FIELDS_NAME.STATUS, headerName: PROVIDERS_HEADER_TITLES.STATUS, sortable: false, flex: 1 },
	{ field: PROVIDERS_FIELDS_NAME.CREATED_AT, headerName: PROVIDERS_HEADER_TITLES.CREATED_AT, sortable: false, flex: 1 },
];
